module.exports = __webpack_public_path__ + "static/media/Scumbag Joe.4e54ca54.png";